import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Button, Input, Label } from "reactstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateProgram } from "../../../../store/slices/programsSlice";
import { getAddOnMaster } from "../../../../store/slices/clientsSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MbForm from "./mbform";
import SweetAlert from "sweetalert2";
import Select from "react-select";
import { add } from "date-fns";
import allAPI from "../../../../api/api";

const ProgramForm = forwardRef(({ formType }, ref) => {
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState({
    name: "",
    description: "",
    BinAddition: [{ bin_from: "", bin_to: "" }],
    registration_type: "",
    add_details: false,
    additional_details: [],
    program_details: [],
    add_on_services: [],
  });

  const emptyAddon = () => ({ limits: "", limitsValue: "", default_free: "", extraFree: "", purchase_slot: "", total_slot: "", isEnabled: true });
  const [addOnOptions, setAddOnOptions] = useState([]);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [newDetailText, setNewDetailText] = useState("");
  const [subDetailInputs, setSubDetailInputs] = useState({});
  const [detailsOpen, setDetailsOpen] = useState(true);
  const [newProgramDetailText, setNewProgramDetailText] = useState("");
  const [programSubDetailInputs, setProgramSubDetailInputs] = useState({});
  const [programDetailsOpen, setProgramDetailsOpen] = useState(true);
  const [programDetailUploading, setProgramDetailUploading] = useState({});
  const {
    formState: { errors },
  } = useForm({ defaultValues: { name: "", description: "", mb_form: {} } });
  const registrationTypeOptions = [
    { label: "Manual Reg Cards Numbers", value: "Manual Reg Cards Numbers" },
    { label: "Card Number", value: "Card Number" },
  ];
  const programDetails = useSelector((state) => state.programs.programDetail);
  const selectedTenant = useSelector(
    (state) => state.clients.selectedClient?.value,
  );
  const masterAddOns = useSelector((state) => state.clients.masterAddOns);
console.log(programDetails, "programDetails in form");

  useEffect(() => {
    dispatch(getAddOnMaster({ isMaster: true }));
  }, [dispatch]);

  useEffect(() => {
    if (formType === "edit" && programDetails) {
      setFormFields((prev) => ({
        ...prev,
        ...programDetails,
        BinAddition: programDetails.BinAddition ||
          prev.BinAddition || [{ bin_from: "", bin_to: "" }],
        add_details: !!programDetails.add_details,
        // Merge top-level program fields into mb_form so MbForm displays them
        mb_form: {
          ...(programDetails.mb_form || {}),
          validity: programDetails.validity ?? programDetails.mb_form?.validity ?? "",
          plan_type: programDetails.plan_type ?? programDetails.mb_form?.plan_type ?? "",
          program_type: programDetails.program_type ?? programDetails.mb_form?.program_type ?? "",
          amount: programDetails.amount ?? programDetails.mb_form?.amount ?? "",
          plan_activation: programDetails.plan_activation ?? programDetails.mb_form?.plan_activation ?? "",
        },
        add_on_services: Array.isArray(programDetails.add_on_services)
          ? programDetails.add_on_services.map((s) => ({
            limits: s.serviceName ?? s.limits ?? s.name ?? "",
            limitsValue: s.ID ?? s.id ?? s.limitsValue ?? "",
            default_free: s.defaultFree != null ? String(s.defaultFree) : (s.default_free ?? ""),
            extraFree: s.extraFree ?? "",
            purchase_slot: s.purchaseSLot != null ? String(s.purchaseSLot) : (s.purchase_slot ?? ""),
            total_slot: s.maxSlot != null ? String(s.maxSlot) : (s.total_slot ?? ""),
            isEnabled: s.isEnable !== undefined ? !!s.isEnable : (s.isEnabled !== undefined ? !!s.isEnabled : true),
            personal_identity: !!(s.personal_identity ?? s.personalIdentity ?? s.personalIdentity ?? true),
            financial_identity: !!(s.financial_identity ?? s.financialIdentity ?? false),
            digital_itendity: !!(s.digital_itendity ?? s.digitalItendity ?? false),
            serviceKey: s.serviceKey ?? s.service_key ?? s.serviceName ?? s.name ?? "",
          }))
          : [],
        additional_details: Array.isArray(programDetails.additional_details)
          ? programDetails.additional_details.map((d) => {
              const base = typeof d === "string" ? { text: d, subDetails: [] } : { ...d };
              base.subDetails = (base.subDetails || []).map((s) =>
                typeof s === "string" ? { text: s } : { text: s.text ?? s }
              );
              return base;
            })
          : [],
        program_details: Array.isArray(programDetails.program_details)
          ? programDetails.program_details.map((d) => {
              const base = typeof d === "string" ? { text: d, subDetails: [], image_url: "" } : { ...d };
              base.subDetails = (base.subDetails || []).map((s) =>
                typeof s === "string" ? { text: s } : { text: s.text ?? s }
              );
              base.image_url = base.image_url || "";
              return base;
            })
          : [],
      }));
    }
  }, [programDetails, formType]);
  const addAddon = () => {
    // Find full master record to pre-fill defaults
    const masterSource = Array.isArray(masterAddOns) && masterAddOns.length > 0 ? masterAddOns : [];
    const masterRecord = selectedMaster
      ? masterSource.find((m) => (m.ID ?? m.id) === selectedMaster.value) || null
      : null;

    const newRow = masterRecord
      ? {
          limits:
            masterRecord.serviceName ??
            masterRecord.name ??
            selectedMaster.label ??
            "",
          limitsValue:
            masterRecord.ID ?? masterRecord.id ?? selectedMaster.value ?? "",
          default_free:
            masterRecord.defaultFree != null
              ? String(masterRecord.defaultFree)
              : "",
          extraFree: "",
          purchase_slot:
            masterRecord.purchaseSLot != null
              ? String(masterRecord.purchaseSLot)
              : "",
          total_slot:
            masterRecord.maxSlot != null ? String(masterRecord.maxSlot) : "",
          isEnabled:
            masterRecord.isEnable !== undefined
              ? !!masterRecord.isEnable
              : true,
          personal_identity: !!(
            masterRecord.personalIdentity ?? masterRecord.personal_identity ?? true
          ),
          financial_identity: !!(
            masterRecord.financialIdentity ?? masterRecord.financial_identity ?? false
          ),
          digital_itendity: !!(
            masterRecord.digitalItendity ?? masterRecord.digital_itendity ?? false
          ),
          serviceKey:
            masterRecord.serviceKey ?? masterRecord.service_key ?? masterRecord?.serviceName ?? masterRecord?.name ?? "",
          
        }
      : {
          ...emptyAddon(),
          limitsValue: selectedMaster?.value ?? addOnOptions?.[0]?.value ?? "",
          limits: selectedMaster?.label ?? addOnOptions?.[0]?.label ?? "",
        };

    setFormFields((prev) => ({
      ...prev,
      add_on_services: [...prev.add_on_services, newRow],
    }));
  };

  const removeAddon = (index) => {
    setFormFields((prev) => ({
      ...prev,
      add_on_services: prev.add_on_services.filter((_, i) => i !== index),
    }));
  };

  const updateAddon = (index, field, value) => {
    setFormFields((prev) => ({
      ...prev,
      add_on_services: prev.add_on_services.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      ),
    }));
  };

  const addDetail = () => {
    const text = newDetailText.trim();
    if (!text) return;
    setFormFields((prev) => ({
      ...prev,
      additional_details: [...prev.additional_details, { text, subDetails: [] }],
    }));
    setNewDetailText("");
  };

  // Derive add-on master options from programDetails or existing form rows
  useEffect(() => {
    const derive = (arr) =>
      Array.isArray(arr)
        ? arr.map((it) => {
            if (typeof it === "string") return { label: it, value: it };
            const label = it.serviceName ?? it.name ?? it.label ?? it.title ?? String(it);
            const value = it.ID ?? it.id ?? it.value ?? it.limitsValue ?? it.limits ?? label;
            return { label, value };
          })
        : [];

    // prefer master list from redux store, then programDetails, then current form rows
    const source = Array.isArray(masterAddOns) && masterAddOns.length > 0
      ? masterAddOns
      : (Array.isArray(programDetails?.add_on_services) && programDetails.add_on_services.length > 0
        ? programDetails.add_on_services
        : formFields.add_on_services);

    const opts = derive(source);
    setAddOnOptions(opts);

    // set selected master to first option when options load if none selected
    if (!selectedMaster && opts.length > 0) setSelectedMaster(opts[0]);

  }, [masterAddOns, programDetails]);

  const removeDetail = (index) => {
    setFormFields((prev) => ({
      ...prev,
      additional_details: prev.additional_details.filter((_, i) => i !== index),
    }));
    setSubDetailInputs((prev) => {
      const next = { ...prev };
      delete next[index];
      return next;
    });
  };

  const addSubDetail = (detailIndex) => {
    const text = (subDetailInputs[detailIndex] || "").trim();
    if (!text) return;
    setFormFields((prev) => {
      const details = prev.additional_details.map((d, i) =>
        i === detailIndex
          ? { ...d, subDetails: [...(d.subDetails || []), { text }] }
          : d
      );
      return { ...prev, additional_details: details };
    });
    setSubDetailInputs((prev) => ({ ...prev, [detailIndex]: "" }));
  };

  const removeSubDetail = (detailIndex, subIndex) => {
    setFormFields((prev) => {
      const details = prev.additional_details.map((d, i) =>
        i === detailIndex
          ? { ...d, subDetails: (d.subDetails || []).filter((_, si) => si !== subIndex) }
          : d
      );
      return { ...prev, additional_details: details };
    });
  };

  // --- Program Details (with optional image) ---
  const addProgramDetail = () => {
    const text = newProgramDetailText.trim();
    if (!text) return;
    setFormFields((prev) => ({ ...prev, program_details: [...(prev.program_details || []), { text, subDetails: [], image_url: "" }] }));
    setNewProgramDetailText("");
  };

  const removeProgramDetail = (index) => {
    setFormFields((prev) => ({ ...prev, program_details: (prev.program_details || []).filter((_, i) => i !== index) }));
    setProgramSubDetailInputs((prev) => { const next = { ...prev }; delete next[index]; return next; });
    setProgramDetailUploading((prev) => { const next = { ...prev }; delete next[index]; return next; });
  };

  const addProgramSubDetail = (detailIndex) => {
    const text = (programSubDetailInputs[detailIndex] || "").trim();
    if (!text) return;
    setFormFields((prev) => ({
      ...prev,
      program_details: (prev.program_details || []).map((d, i) =>
        i === detailIndex ? { ...d, subDetails: [...(d.subDetails || []), { text }] } : d
      ),
    }));
    setProgramSubDetailInputs((prev) => ({ ...prev, [detailIndex]: "" }));
  };

  const removeProgramSubDetail = (detailIndex, subIndex) => {
    setFormFields((prev) => ({
      ...prev,
      program_details: (prev.program_details || []).map((d, i) =>
        i === detailIndex ? { ...d, subDetails: (d.subDetails || []).filter((_, si) => si !== subIndex) } : d
      ),
    }));
  };

  const uploadProgramDetailImage = async (index, file) => {
    if (!file) return;
    setProgramDetailUploading((prev) => ({ ...prev, [index]: true }));
    try {
      const fd = new FormData();
      fd.append("image", file);
      const mediaRes = await allAPI.clients.uploadMedia(fd);
      const path = mediaRes?.data?.data?.image?.[0]?.path || mediaRes?.data?.filename || mediaRes?.data?.fileName || mediaRes?.data?.id || mediaRes?.data;
      if (path) {
        setFormFields((prev) => ({
          ...prev,
          program_details: (prev.program_details || []).map((d, i) => (i === index ? { ...d, image_url: path } : d)),
        }));
      }
    } catch (err) {
      console.error("Failed to upload program detail image:", err);
    } finally {
      setProgramDetailUploading((prev) => ({ ...prev, [index]: false }));
    }
  };

  /*****Image Upload on APP */
   const uploadProgramDetailImageAPP = async (index, file) => {
    if (!file) return;
    setProgramDetailUploading((prev) => ({ ...prev, [index]: true }));
    try {
      const fd = new FormData();
      fd.append("image", file);
      const mediaRes = await allAPI.clients.uploadMedia(fd);
      const path = mediaRes?.data?.data?.image?.[0]?.path || mediaRes?.data?.filename || mediaRes?.data?.fileName || mediaRes?.data?.id || mediaRes?.data;
      if (path) {
        setFormFields((prev) => ({
          ...prev,
          program_details: (prev.program_details || []).map((d, i) => (i === index ? { ...d, image_url_app : path } : d)),
        }));
      }
    } catch (err) {
      console.error("Failed to upload program detail image:", err);
    } finally {
      setProgramDetailUploading((prev) => ({ ...prev, [index]: false }));
    }
  };

  const removeProgramDetailImage = (index) => {
    setFormFields((prev) => ({
      ...prev,
      program_details: (prev.program_details || []).map((d, i) => (i === index ? { ...d, image_url: "" } : d)),
    }));
  };

  const removeProgramDetailImageAPP = (index) => {
    setFormFields((prev) => ({
      ...prev,
      program_details: (prev.program_details || []).map((d, i) => (i === index ? { ...d, image_url_app: "" } : d)),
    }));
  };

  const handleInput = (event, field) => {
    let value;
    if (field === "description") {
      value = event;
    } else if (field === "type") {
      value = event?.value;
    } else {
      value = event.target.value;
    }
    setFormFields((prev) => ({ ...prev, [field]: value }));
  };

  async function handleUpdate() {
    // mb_form contains validity, plan_type, plan_activation, program_type, days
    // which the backend reads from the top level — merge them in before dispatching.
    const payload = {
      ...formFields,
      ...(formFields.mb_form || {}),
    };
    const program = await dispatch(updateProgram(payload));

    if (program.type === "programData/updateProgram/fulfilled") {
      SweetAlert.fire("Success", "Program updated successfully!", "success");
    } else {
      SweetAlert.fire("Error", "Failed to update Program.", "error");
    }
  }
  console.log("Form Fields:", addOnOptions, formFields);

  const handleBinNumberChange = (index, field, value) => {
    const updatedBinNumbers = [...formFields.BinAddition];
    updatedBinNumbers[index] = { ...updatedBinNumbers[index], [field]: value };
    setFormFields((prev) => ({
      ...prev,
      BinAddition: updatedBinNumbers,
    }));
  };

  const addBinNumber = () => {
    setFormFields((prev) => ({
      ...prev,
      BinAddition: [...prev.BinAddition, { bin_from: "", bin_to: "" }],
    }));
  };

  const removeBinNumber = (index) => {
    const updatedBinNumbers = formFields.BinAddition.filter(
      (_, i) => i !== index,
    );
    setFormFields((prev) => ({
      ...prev,
      BinAddition: updatedBinNumbers,
    }));
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  return (
    <div className="px-2">
      <div>
        <Label>Program Name</Label>
        <Input
          name="name"
          type="text"
          placeholder="Enter program name"
          value={formFields.name}
          onChange={(event) => handleInput(event, "name")}
        />
        {errors.name && (
          <span className="mt-1 text-danger">{errors.name.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Program Description</Label>
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          value={formFields.description}
          onChange={(event) => handleInput(event, "description")}
        />
        {errors.description && (
          <span className="mt-1 text-danger">{errors.description.message}</span>
        )}
      </div>
      <div className="mt-4">
        <MbForm
          value={formFields.mb_form}
          formFields={formFields}
          handleInput={handleInput}
          onChange={(data) =>
            setFormFields((prev) => ({
              ...prev,
              mb_form: data,
            }))
          }
        />
      </div>
      {(selectedTenant === "axis" || selectedTenant === "hc") && (
        <>
          <div className="mt-2">
            <Label>Select Registration Type</Label>
            <Select
              options={registrationTypeOptions}
              isClearable={true}
              placeholder="Select registration type"
              value={registrationTypeOptions.find(
                (opt) => opt.value === formFields.registration_type,
              )}
              onChange={(option) => {
                setFormFields((prev) => ({
                  ...prev,
                  registration_type: option?.value || "",
                  BinAddition:
                    option?.value === "Manual Reg Cards Numbers"
                      ? []
                      : [],
                }));
              }}
            />
          </div>

          {formFields.registration_type && (
            <div className="mt-2">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Label className="mb-0">Enter Bin Number:</Label>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={addBinNumber}
                  title="Add bin number"
                >
                  + Add Bin
                </button>
              </div>
              {formFields.BinAddition?.map((bin, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-2 mt-2"
                >
                  <div className="flex-fill">
                    <Input
                      type="text"
                      placeholder="From"
                      value={bin.bin_from}
                      onChange={(e) =>
                        handleBinNumberChange(index, "bin_from", e.target.value)
                      }
                    />
                  </div>
                  <div className="flex-fill">
                    <Input
                      type="text"
                      placeholder="To"
                      value={bin.bin_to}
                      onChange={(e) =>
                        handleBinNumberChange(index, "bin_to", e.target.value)
                      }
                    />
                  </div>
                  {formFields.BinAddition.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => removeBinNumber(index)}
                      title="Remove bin number"
                    >
                      X
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {/* Additional Details */}
      <div className="mt-4" style={{ border: "1px solid #dee2e6", borderRadius: 8, overflow: "hidden", background: "#fff" }}>
        {/* Accordion header */}
        <div
          className="d-flex align-items-center justify-content-between px-3 py-2"
          style={{ background: "#e9ecef", borderBottom: detailsOpen ? "1px solid #ced4da" : "none", cursor: "pointer", userSelect: "none" }}
          onClick={() => setDetailsOpen((o) => !o)}
        >
          <div className="d-flex align-items-center gap-2" onClick={(e) => e.stopPropagation()}>
      
            <Label for="add_details_toggle" className="mb-0 fw-semibold" style={{ cursor: "pointer", fontSize: 14 }} onClick={(e) => e.stopPropagation()}>
              Add Details
            </Label>
          </div>
          <span style={{ fontSize: 12, color: "#6c757d" }}>{detailsOpen ? "▲" : "▼"}</span>
        </div>

     
          <div style={{ padding: "14px 16px" }}>
    
          <div className="mt-3">
            {/* Top-level add input */}
            <div className="d-flex gap-2 mb-3">
              <Input
                type="text"
                placeholder="Enter detail title…"
                value={newDetailText}
                onChange={(e) => setNewDetailText(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addDetail(); } }}
                style={{ fontSize: 13, borderRadius: 6 }}
              />
              <button
                type="button"
                className="btn btn-primary btn-sm px-3"
                style={{ whiteSpace: "nowrap", borderRadius: 6 }}
                onClick={addDetail}
              >
                + Add
              </button>
            </div>

            {/* Detail cards */}
            <div className="d-flex flex-column gap-3">
              {formFields.additional_details.map((detail, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: 8,
                    background: "#f8f9fa",
                    overflow: "hidden",
                  }}
                >
                  {/* Card header */}
                  <div
                    className="d-flex justify-content-between align-items-center px-3 py-2"
                    style={{ background: "#e9ecef", borderBottom: "1px solid #ced4da" }}
                  >
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#343a40" }}>
                      {index + 1}.&nbsp;{detail.text}
                    </span>
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4 }}
                      onClick={() => removeDetail(index)}
                      title="Remove detail"
                    >
                      Remove
                    </button>
                  </div>

                  {/* Card body */}
                  <div className="px-3 py-2">
                    {/* Sub-detail input */}
                    <div className="d-flex gap-2 mb-2">
                      <Input
                        type="text"
                        placeholder="Add sub-detail…"
                        value={subDetailInputs[index] || ""}
                        onChange={(e) =>
                          setSubDetailInputs((prev) => ({ ...prev, [index]: e.target.value }))
                        }
                        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addSubDetail(index); } }}
                        style={{ fontSize: 13, borderRadius: 6, background: "#fff" }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        style={{ whiteSpace: "nowrap", fontSize: 12, borderRadius: 6 }}
                        onClick={() => addSubDetail(index)}
                      >
                        + Add
                      </button>
                    </div>

                    {/* Sub-detail rows */}
                    {(detail.subDetails || []).length > 0 && (
                      <div className="d-flex flex-column gap-1 mt-1">
                        {detail.subDetails.map((sub, si) => (
                          <div
                            key={si}
                            className="d-flex align-items-center justify-content-between"
                            style={{
                              background: "#fff",
                              border: "1px solid #dee2e6",
                              borderRadius: 6,
                              padding: "5px 10px",
                              fontSize: 12,
                            }}
                          >
                            <span style={{ color: "#495057" }}>
                              {sub.text}
                            </span>
                            <button
                              type="button"
                              onClick={() => removeSubDetail(index, si)}
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                                color: "#dc3545",
                                fontSize: 16,
                                lineHeight: 1,
                              }}
                              title="Remove"
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
      
          </div>
      
      </div>
      {/* Add Program Details */}
      <div className="mt-4" style={{ border: "1px solid #dee2e6", borderRadius: 8, overflow: "hidden", background: "#fff" }}>
        <div
          className="d-flex align-items-center justify-content-between px-3 py-2"
          style={{ background: "#e9ecef", borderBottom: programDetailsOpen ? "1px solid #ced4da" : "none", cursor: "pointer", userSelect: "none" }}
          onClick={() => setProgramDetailsOpen((o) => !o)}
        >
          <div className="d-flex align-items-center gap-2" onClick={(e) => e.stopPropagation()}>
            <Label for="add_program_details_toggle" className="mb-0 fw-semibold" style={{ cursor: "pointer", fontSize: 14 }} onClick={(e) => e.stopPropagation()}>
              Add Program Details
            </Label>
          </div>
          <span style={{ fontSize: 12, color: "#6c757d" }}>{programDetailsOpen ? "▲" : "▼"}</span>
        </div>

        <div style={{ padding: "14px 16px" }}>
          <div className="d-flex gap-2 mb-3">
            <Input
              type="text"
              placeholder="Enter program detail title…"
              value={newProgramDetailText}
              onChange={(e) => setNewProgramDetailText(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addProgramDetail(); } }}
              style={{ fontSize: 13, borderRadius: 6 }}
            />
            <button type="button" className="btn btn-primary btn-sm px-3" style={{ whiteSpace: "nowrap", borderRadius: 6 }} onClick={addProgramDetail}>
              + Add
            </button>
          </div>
          <div className="d-flex flex-column gap-3">
            {formFields.program_details.map((detail, index) => (
              <div key={index} style={{ border: "1px solid #ced4da", borderRadius: 8, background: "#f8f9fa", overflow: "hidden" }}>
                <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ background: "#e9ecef", borderBottom: "1px solid #ced4da" }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#343a40" }}>{index + 1}.&nbsp;{detail.text}</span>
                  <button type="button" className="btn btn-sm btn-danger" style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4 }} onClick={() => removeProgramDetail(index)} title="Remove detail">Remove</button>
                </div>
                <div className="px-3 py-2">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <label
                      htmlFor={`prog-detail-img-${index}`}
                      className="btn btn-sm btn-outline-secondary mb-0"
                      style={{ fontSize: 12, borderRadius: 6, cursor: "pointer" }}
                    >
                      {programDetailUploading[index] ? "Uploading…" : detail.image_url ? "Change Image" : "Upload Image"}
                    </label>
                    <input
                      id={`prog-detail-img-${index}`}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) uploadProgramDetailImage(index, file);
                        e.target.value = "";
                      }}
                    />
                    {detail.image_url && (
                      <>
                        <img
                          src={`${process.env.REACT_APP_PL_API}/media/reqMedia/${detail.image_url}`}
                          alt="detail"
                          style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4, border: "1px solid #ced4da" }}
                          onError={(e) => { 
                            // e.target.style.display = "none";
                           }}
                        />
                        <button
                          type="button"
                          onClick={() => removeProgramDetailImage(index)}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "#dc3545", fontSize: 12 }}
                          title="Remove image"
                        >
                          Remove image
                        </button>
                      </>
                    )}
                  </div>
                  {/****APP Icons */}
                   <div className="d-flex align-items-center gap-2 mb-2">
                    <label
                      htmlFor={`prog-detail-img-app-${index}`}
                      className="btn btn-sm btn-outline-secondary mb-0"
                      style={{ fontSize: 12, borderRadius: 6, cursor: "pointer" }}
                    >
                      {programDetailUploading[index] ? "Uploading…" : detail.image_url_app ? "Change app Icon" : "Upload app Image"}
                    </label>
                    <input
                      id={`prog-detail-img-app-${index}`}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) uploadProgramDetailImageAPP(index, file);
                        e.target.value = "";
                      }}
                    />
                    {detail.image_url_app && (
                      <>
                        <img
                          src={`${process.env.REACT_APP_PL_API}/media/reqMedia/${detail?.image_url_app}`}
                          alt="detail"
                          style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4, border: "1px solid #ced4da" }}
                          onError={(e) => { e.target.style.display = "none"; }}
                        />
                        <button
                          type="button"
                          onClick={() => removeProgramDetailImageAPP(index)}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "#dc3545", fontSize: 12 }}
                          title="Remove image"
                        >
                          Remove app image
                        </button>
                      </>
                    )}
                  </div>
                  <div className="d-flex gap-2 mb-2">
                    <Input
                      type="text"
                      placeholder="Add sub-detail…"
                      value={programSubDetailInputs[index] || ""}
                      onChange={(e) => setProgramSubDetailInputs((prev) => ({ ...prev, [index]: e.target.value }))}
                      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addProgramSubDetail(index); } }}
                      style={{ fontSize: 13, borderRadius: 6, background: "#fff" }}
                    />
                    <button type="button" className="btn btn-sm btn-outline-primary" style={{ whiteSpace: "nowrap", fontSize: 12, borderRadius: 6 }} onClick={() => addProgramSubDetail(index)}>+ Add</button>
                  </div>
                  {(detail.subDetails || []).length > 0 && (
                    <div className="d-flex flex-column gap-1 mt-1">
                      {detail.subDetails.map((sub, si) => (
                        <div key={si} className="d-flex align-items-center justify-content-between" style={{ background: "#fff", border: "1px solid #dee2e6", borderRadius: 6, padding: "5px 10px", fontSize: 12 }}>
                          <span style={{ color: "#495057" }}>{sub.text}</span>
                          <button type="button" onClick={() => removeProgramSubDetail(index, si)} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "#dc3545", fontSize: 16, lineHeight: 1 }} title="Remove">&times;</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

      {/* Add-on Service List */}
      <div className="mt-4" style={{ border: "1px solid #dee2e6", borderRadius: 8, padding: "14px 16px", background: "#fff" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="fw-semibold" style={{ fontSize: 14 }}>Add-on Service List</span>
          <div className="d-flex align-items-center gap-2">
            {addOnOptions.length > 0 && (
              <div style={{ minWidth: 220 }}>
                <Select
                  options={addOnOptions}
                  value={selectedMaster}
                  onChange={(val) => setSelectedMaster(val)}
                  isClearable={false}
                  placeholder="Select master"
                  styles={{ container: (base) => ({ ...base, minWidth: 220 }) }}
                />
              </div>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm px-3"
              style={{ borderRadius: 6, fontSize: 12 }}
              onClick={addAddon}
            >
              + Add Row
            </button>
          </div>
        </div>

        {formFields.add_on_services.length > 0 ? (
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-sm mb-0" style={{ fontSize: 12, minWidth: 600 }}>
              <thead style={{ background: "#e9ecef" }}>
                <tr>
                  <th style={{ width: 36, textAlign: "center" }}>Enable</th>
                  <th>Limits</th>
                  <th>Default Free</th>
                  <th>Extra Free</th>
                  <th>Purchase Slot</th>
                  <th>Total Slot</th>
                  <th style={{ width: 60, textAlign: "center" }}>Remove</th>
                </tr>
              </thead>
              <tbody>
                {formFields.add_on_services.map((row, index) => (
                  <tr key={index} style={{ verticalAlign: "middle", opacity: row.isEnabled ? 1 : 0.5 }}>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={!!row.isEnabled}
                        onChange={() => updateAddon(index, "isEnabled", !row.isEnabled)}
                        style={{
                          width: 15,
                          height: 15,
                          cursor: "pointer",
                          marginTop: 0,
                          opacity: 1,
                          position: "relative",
                          zIndex: 2,
                          WebkitAppearance: "checkbox",
                          MozAppearance: "checkbox",
                          appearance: "checkbox",
                          background: "transparent",
                        }}
                        title={row.isEnabled ? "Enabled" : "Disabled"}
                      />
                    </td>
                    <td>
                      <span style={{ fontSize: 12 }}>{row.limits || "—"}</span>
                    </td>
                    {["default_free", "extraFree", "purchase_slot", "total_slot"].map((field) => (
                      <td key={field}>
                        <Input
                          type="text"
                          value={row[field]}
                          onChange={(e) => updateAddon(index, field, e.target.value)}
                          style={{ fontSize: 12, padding: "3px 6px", border: "none", boxShadow: "none", background: "transparent" }}
                          placeholder="—"
                        />
                      </td>
                    ))}
                    <td style={{ textAlign: "center" }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        style={{ fontSize: 11, padding: "2px 8px", borderRadius: 4 }}
                        onClick={() => removeAddon(index)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-muted mb-0" style={{ fontSize: 13 }}>No add-on services added yet.</p>
        )}
      </div>

      <Button className="mt-4 bg-primary w-100" onClick={handleUpdate}>
        Update
      </Button>
    </div>
    </div>
  );
});

export default ProgramForm;
